import { createFileRoute } from '@tanstack/react-router';

import { ForecastPage } from '@/features/insights/forecast-panel';

export const Route = createFileRoute('/_app/projects/$projectId/insights/forecast')({
  component: ForecastRoute,
});

function ForecastRoute() {
  const { projectId } = Route.useParams();
  return <ForecastPage projectId={projectId} />;
}
